<div id="register-container">
  <div class="info-content">
    <img src="/assets/images/logo.png" alt="" class="logo" />
    <h1> {{ "form_register_app.header_title" | translate }} </h1>
  </div>

  <div class="form-container">
    <!-- Alert box -->
    <div class="alert al-danger" *ngIf="showAlertBox">
      <img class="x-mark" src="/assets/icons/x-mark.svg" (click)="showAlertBox = !showAlertBox" />
      <p> {{ alertMessage }} </p>
    </div>
    <div class="form-title">
      <h1 class="form-title-content">
        {{ "form_register_app.form_register.header_title" | translate }}
      </h1>
    </div>

    <form class="register-form" #registerForm="ngForm" (ngSubmit)="onRegister()" novalidate>
      <!-- Email Signin -->
      <mat-form-field class="full-width" hideRequiredMarker>
        <mat-label class="place-holder">
          {{ "form_register_app.form_register.email" | translate }}
        </mat-label>
        <input #email="ngModel" type="email" matInput name="username" [(ngModel)]="username" [disabled]="submiting"
          pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" required autocomplete="off" />
        <mat-error *ngIf="email.errors?.['required'] && email.touched">
          {{ "form_register_app.form_register.email_required" | translate }}
        </mat-error>
        <mat-error *ngIf="email.errors?.['pattern']">
          {{ "form_register_app.form_register.email_regex" | translate }}
        </mat-error>
      </mat-form-field>

      <!-- password -->
      <mat-form-field class="full-width" hideRequiredMarker>
        <mat-label class="place-holder">
          {{ "form_register_app.form_register.password" | translate }}
        </mat-label>
        <input matInput name="password" [type]="isShowPassword ? 'text' : 'password'" [(ngModel)]="password"
          #pass="ngModel" required [disabled]="submiting" pattern="^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,15}$"
          autocomplete="off" />
        <button tabindex="-1" type="button" mat-icon-button matSuffix aria-label="Show password"
          (click)="isShowPassword = !isShowPassword">
          <mat-icon> {{ isShowPassword ? 'visibility' : 'visibility_off' }} </mat-icon>
        </button>
        <mat-hint align="start">
          {{ "form_register_app.form_register.password_regex" | translate }}
        </mat-hint>
        <mat-error *ngIf="pass.errors?.['required'] && pass.touched">
          {{ "form_register_app.form_register.password_required" | translate }}
        </mat-error>
        <mat-error *ngIf="pass.errors?.['pattern']">
          {{ "form_register_app.form_register.password_regex" | translate }}
        </mat-error>
      </mat-form-field>

      <!-- confirm password -->
      <mat-form-field class="full-width confirm-password-box" hideRequiredMarker>
        <mat-label class="place-holder">
          {{ "form_register_app.form_register.confirm_password" | translate }}
        </mat-label>
        <input matInput name="confirmPassword" [type]="isConfirmShowPassword ? 'text' : 'password'"
          [(ngModel)]="confirmPassword" #confirm_pass="ngModel" required [disabled]="submiting" autocomplete="off" />
        <button tabindex="-1" type="button" mat-icon-button matSuffix aria-label="Show password"
          (click)="isConfirmShowPassword = !isConfirmShowPassword">
          <mat-icon>{{ isConfirmShowPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
        </button>
        <mat-error *ngIf="confirm_pass.invalid || confirm_pass.untouched">
          {{ "form_register_app.form_register.confirm_password_required" | translate }}
        </mat-error>
        <small class="error-label" *ngIf="!matchPassword">
          {{ alertMessage }}
        </small>
      </mat-form-field>
      <!-- first name -->
      <mat-form-field class="full-width" hideRequiredMarker>
        <mat-label class="place-holder">
          {{ "form_register_app.form_register.firstname" | translate }}
        </mat-label>
        <input type="text" matInput name="firstname" [(ngModel)]="firstname" required #firstName="ngModel" required
          [disabled]="submiting" autocomplete="off" />
        <mat-error *ngIf="firstName.invalid || firstName.untouched">
          {{ "form_register_app.form_register.firstname_required" | translate }}
        </mat-error>
      </mat-form-field>

      <!-- middle name -->
      <mat-form-field class="full-width" hideRequiredMarker>
        <mat-label class="place-holder">
          {{ "form_register_app.form_register.middlename" | translate }}
        </mat-label>
        <input type="text" matInput name="middlename" [(ngModel)]="middlename" [disabled]="submiting"
          autocomplete="off" />
      </mat-form-field>

      <!-- last name -->
      <mat-form-field class="full-width" hideRequiredMarker>
        <mat-label class="place-holder">
          {{ "form_register_app.form_register.lastname" | translate }}
        </mat-label>
        <input type="text" matInput name="lastname" [(ngModel)]="lastname" required #last_name="ngModel"
          [disabled]="submiting" autocomplete="off" />
        <mat-error *ngIf="last_name.invalid || last_name.untouched">
          {{ "form_register_app.form_register.lastname_required" | translate }}
        </mat-error>
      </mat-form-field>
      <!-- language -->
      <mat-form-field class="full-width">
        <mat-label class="place-holder">
          {{ "form_register_app.form_register.default_language" | translate }}
        </mat-label>
        <mat-select [(ngModel)]="language" name="language" required #lang="ngModel" [disabled]="submiting">
          <mat-option>
            <ngx-mat-select-search [formControl]="filteringCtrl"
              placeholderLabel="{{'form_register_app.search.search_language' | translate }}"
              noEntriesFoundLabel="{{'form_register_app.search.notfound_language' | translate }}">
            </ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let lang of languages | orderBy: searchingText:'name'" [value]="lang.id">
            <div class="lang-list">
              <img with="20" height="20" src="/assets/images/flags/{{ lang.id }}.png" alt="{{ lang.name }}" />
              <div> {{ lang.name }} </div>
            </div>
          </mat-option>
        </mat-select>
        <mat-error required *ngIf="lang.invalid || lang.untouched">
          {{ "form_register_app.form_register.default_language_required" | translate }}
        </mat-error>
      </mat-form-field>
      <button type="submit" mat-button class="btn btn-register" mat-flat-button [disabled]="registerForm.form.invalid" [disabled]="submiting"
        [class]="{ 'btn-disbled': registerForm.form.invalid || submiting }">
        <span class="btn-content">
          {{ "form_register_app.form_register.register_button" | translate }}
        </span>
      </button>
      <div class="register-form-info">
        <p> {{ 'form_register_app.form_register.signin_label' | translate }} </p>
        <a routerLink="/login"> {{ 'form_register_app.form_register.signin_link' | translate }} </a>
      </div>
    </form>
  </div>
</div>